import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-770bf474")

_pushScopeId("data-v-770bf474")
const _hoisted_1 = { class: "ExpressOrdersList" }
const _hoisted_2 = { class: "ExpressOrdersList__header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "ExpressOrdersList__list scroll green" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"list__header\" data-v-770bf474><div class=\"list__row header\" data-v-770bf474><div class=\"list__col first header\" data-v-770bf474>ID</div><div class=\"list__col second header\" data-v-770bf474>Дата заказа</div><div class=\"list__col third header\" data-v-770bf474>Статус</div><div class=\"list__col fourth header\" data-v-770bf474>Адрес забора</div><div class=\"list__col fifth header\" data-v-770bf474>Отслеживание на карте</div><div class=\"list__col sixth header\" data-v-770bf474></div></div></div>", 1)
const _hoisted_6 = { class: "list__body" }
const _hoisted_7 = { class: "list__col first col-big" }
const _hoisted_8 = { class: "list__col second" }
const _hoisted_9 = { class: "list__col third" }
const _hoisted_10 = { class: "list__col fourth" }
const _hoisted_11 = { class: "list__col fifth" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Подробнее ")
const _hoisted_14 = {
  key: 1,
  class: "list__row empty"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "list__col full" }, "Нет заказов", -1)
const _hoisted_16 = {
  key: 1,
  class: "ExpressOrdersList__loading"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_refresh = _resolveComponent("icon-refresh")!
  const _component_express_status = _resolveComponent("express-status")!
  const _component_express_link = _resolveComponent("express-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_s_loader = _resolveComponent("s-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.withRefresh)
        ? (_openBlock(), _createBlock(_component_icon_refresh, {
            key: 0,
            class: "header__refresh",
            onClick: _ctx.emitRefresh
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              (_ctx.orders && _ctx.orders.length > 0)
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.orders, (order, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "list__row",
                      key: `ExpressOrdersList-order-${i}`
                    }, [
                      _createVNode("div", _hoisted_7, _toDisplayString(order.id), 1),
                      _createVNode("div", _hoisted_8, _toDisplayString(order.created_at), 1),
                      _createVNode("div", _hoisted_9, [
                        _createVNode(_component_express_status, {
                          "was-returned": order.was_returned,
                          "status-number": order.status,
                          status: order.statusDescription
                        }, null, 8, ["was-returned", "status-number", "status"])
                      ]),
                      _createVNode("div", _hoisted_10, _toDisplayString(order.from_address), 1),
                      _createVNode("div", _hoisted_11, [
                        (order.status === 2)
                          ? (_openBlock(), _createBlock(_component_express_link, {
                              key: 0,
                              id: order.id
                            }, null, 8, ["id"]))
                          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              _hoisted_12
                            ], 64))
                      ]),
                      _createVNode(_component_router_link, {
                        to: `/express/${order.id}`,
                        class: "list__col seventh col-shadow"
                      }, {
                        default: _withId(() => [
                          _hoisted_13
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock("div", _hoisted_14, [
                    _hoisted_15
                  ]))
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 64))
      : (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode(_component_s_loader)
        ]))
  ]))
})